<!-- SELECIONADO: o card do cliente, na casca padrão do app-content-card (tom de aviso com títulos em atraso) -->
@if (clienteSelecionado) {
  <app-content-card icon="storefront" [title]="clienteSelecionado.nome" [tone]="temTitulosEmAtraso ? 'warning' : 'plain'">
    <div>
      <div class="card-meta">
        @if (clienteSelecionado.documento) {
          <span>
            <mat-icon class="material-symbols-outlined">badge</mat-icon>
            {{ clienteSelecionado.documento | cpfCnpj }}
          </span>
        }
        @if (localidade) {
          <span>
            <mat-icon class="material-symbols-outlined">location_on</mat-icon>
            {{ localidade }}
          </span>
        }
      </div>

      @if (isCarregandoDadosDoCliente) {
        <div class="status-badge badge-cinza chip-card">
          <mat-spinner diameter="14"></mat-spinner>
          Consultando o financeiro…
        </div>
      } @else if (temTitulosEmAtraso) {
        <div class="status-badge badge-vermelho chip-card">
          <mat-icon class="material-symbols-outlined">error</mat-icon>
          Cliente com títulos em atraso
        </div>
      } @else if (limiteDisponivel != null && limiteDisponivel < 0) {
        <!-- Em aberto acima do limite do cadastro: o número negativo não é "disponível". -->
        <div class="status-badge badge-vermelho chip-card">
          <mat-icon class="material-symbols-outlined">error</mat-icon>
          Limite de crédito excedido em {{ -limiteDisponivel | abnt: 'preco' : 2 }}
        </div>
      } @else if (limiteDisponivel != null) {
        <div class="status-badge badge-verde chip-card">
          <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
          Limite disponível {{ limiteDisponivel | abnt: 'preco' : 2 }}
        </div>
      }
    </div>

    <ng-container ngProjectAs="[contentCardActions]">
      @if (!isSomenteLeitura) {
        <!-- O span carrega o tooltip do bloqueio: botão desabilitado não dispara eventos de mouse. -->
        <span class="vdc-trocar" [matTooltip]="motivoClienteBloqueado ?? ''">
          <button type="button" mat-button class="btn-trocar" [disabled]="!!motivoClienteBloqueado" (click)="trocar()"
            [matTooltip]="motivoClienteBloqueado ? '' : 'Trocar de cliente'">
            <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
            Trocar
          </button>
        </span>
      }
    </ng-container>
  </app-content-card>
}

<!-- VAZIO: busca com a lupa da pesquisa avançada -->
@if (!clienteSelecionado) {
  <div class="campo-busca">
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Cliente</mat-label>
      <input
        matInput
        [value]="termo"
        [disabled]="isSomenteLeitura"
        (input)="aoDigitar($any($event.target).value)"
        (focus)="aoFocar()"
        (blur)="fecharDepois()"
        placeholder="Pesquise pelas iniciais do nome, CPF/CNPJ ou e-mail">
      @if (isBuscando) {
        <mat-spinner matSuffix diameter="18"></mat-spinner>
      }

      <!-- Dentro da borda do campo, como no protótipo: a lupa é um refinamento da mesma busca,
           não uma ação separada ao lado dela. -->
      <button matSuffix type="button" class="btn-lupa" [disabled]="isSomenteLeitura"
        (click)="abrirPesquisaAvancada()" matTooltip="Pesquisar cadastro">
        <mat-icon class="material-symbols-outlined">search</mat-icon>
      </button>
    </mat-form-field>

    @if (isDropdownAberto && resultados.length) {
      <div class="vdc-dropdown scroll-suave">
        @for (item of resultados; track item.idPessoa) {
          <button type="button" class="vdc-dropdown-item" (click)="escolher(item)">
            <span class="avatar">{{ inicialDe(item) }}</span>

            <span class="vdc-dropdown-texto">
              <span class="vdc-dropdown-nome">{{ item.nome }}</span>
              @if (item.documento) {
                <span class="vdc-dropdown-detalhe">{{ item.documento | cpfCnpj }}</span>
              }
            </span>

            @if (rotuloDoTipo(item)) {
              <span class="status-badge badge-cinza">{{ rotuloDoTipo(item) }}</span>
            }
          </button>
        }
      </div>
    }
  </div>
}

<!-- Atalhos (§5.1). Só fazem sentido com um cliente escolhido. -->
<div class="atalhos">
  <button type="button" class="atalho" [disabled]="!podeAbrirDetalhe"
    (click)="abrirDetalhe('dados')">dados do cliente</button>
  <button type="button" class="atalho" [disabled]="!podeAbrirDetalhe"
    (click)="abrirDetalhe('vendas')">ver últimas vendas</button>
  <button type="button" class="atalho" [disabled]="!podeAbrirDetalhe"
    (click)="abrirDetalhe('contatos')">pessoas de contato</button>
</div>
